module.exports = new __parcel__URL__("apple_fr.fab94098.jpeg").toString();